import QueryContainer from '@components/setup/QueryContainer';
import { RouterProvider } from '@tanstack/react-router';
import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';
import React, { type FC } from 'react';

import { useAgGridLicense, useAuthStatus } from './hooks';
import './i18n.ts';
import { queryClient } from './lib';
import { router } from './lib/router';

ModuleRegistry.registerModules([AllEnterpriseModule]);

const RouterProviderWithContext: FC = () => {
  useAgGridLicense();
  const authentication = useAuthStatus();

  return <RouterProvider context={{ authentication, queryClient }} router={router} />;
};

const App: FC = () => {
  return (
    <QueryContainer queryClient={queryClient}>
      <RouterProviderWithContext />
    </QueryContainer>
  );
};

export default App;
